import type { FaireProductEntity } from "../../entity_types/product";

export const p_cbynfmmg4t: FaireProductEntity = {
  token: "p_cbynfmmg4t",
  type: "product",
  name: "East Coast Summer Mahjong Game Mat",
  brandToken: "b_ts273nz6z4",
  brandName: "Joni McKown Art",
  imageUrl:
    "https://cdn.faire.com/fastly/6bbbe7f7c1962a8ba61b23a87bbb4a458409196f4d7b0ac876369eb8c4ddb692.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b788d5918e3ab27287ab251c1c409de075071898d4740231f439310081096c79.jpeg",
    "https://cdn.faire.com/fastly/ef0a90a4fec7467f2c977785217450fd18dae81ba0eefba2290e8264e7488b9a.jpeg",
    "https://cdn.faire.com/fastly/eb3fa0596bfdd4e6c561db1457dfec32396a3fe31dc3672aae144b145d773e8c.jpeg",
    "https://cdn.faire.com/fastly/83ffd165019b92caaee8dffe0e6bbe5a280a121cae7a207a729ce55a89ab17c6.jpeg",
    "https://cdn.faire.com/fastly/8162a4fd8e2451ba10647c83b2c19bb3a80b1a7922c7f965a262ea71a64710d8.jpeg",
    "https://cdn.faire.com/fastly/be37471dc8923c5c6e59d551926dc63996f85604adaa4c9c2d7722a341e67e78.jpeg",
  ],
  priceDollars: 42.5,
  description:
    "The East Coast Summer mahjong mats are based on an original watercolor piece by Joni McKown Art, repeated in a silk scarf fashion through graphic design. This refreshing mat has a smooth soft neoprene surface and thick rubber backing. Windmills in four corners showcase a joker through the quaint window and are adorned with summer flower baskets! The border consists of rows of hydrangea sprinkled with beach themed mahjong tiles. Mats are 3mm thick and do not have the curling effect at the borders that some thinner mahjong mats may have. Produced by high end rubber goods manufacturer. ",
  tags: [],
  msrpDollars: 85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:48.477Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
